import React from "react";
import { Link } from "react-router-dom";
import Wordmark from "./Wordmark";
import NewsletterInline from "./NewsletterInline";

const COLS = [
  { title: "Learn", links: [
    { to: "/topic/symptoms", label: "Symptoms" },
    { to: "/topic/diagnosis", label: "Diagnosis" },
    { to: "/topic/treatment", label: "Treatment" },
    { to: "/topic/diet", label: "Diet" },
  ]},
  { title: "Library", links: [
    { to: "/learn", label: "All articles" },
    { to: "/faqs", label: "FAQs" },
    { to: "/resources", label: "Resources & guides" },
  ]},
  { title: "Institute", links: [
    { to: "/faqs", label: "FAQs" },
    { to: "/resources", label: "Resources" },
  ]},
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" style={{ backgroundColor: "var(--olive)", color: "var(--cream)" }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Wordmark tone="cream" />
            <p className="font-serif-editorial mt-8 text-2xl leading-snug" style={{ maxWidth: "22rem" }}>
              Evidence, education, and empowerment — for every step of the SIBO journey.
            </p>
            <div className="mt-10">
              <NewsletterInline tone="cream" testid="footer-newsletter" />
            </div>
          </div>
          <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            {COLS.map((col) => (
              <div key={col.title}>
                <div className="overline" style={{ color: "var(--sand)" }}>{col.title}</div>
                <ul className="mt-4 space-y-3">
                  {col.links.map((l, i) => (
                    <li key={i}>
                      <Link
                        to={l.to}
                        data-testid={`footer-link-${col.title.toLowerCase()}-${i}`}
                        className="text-sm editorial-link"
                        style={{ color: "var(--cream)" }}
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16" style={{ height: 1, backgroundColor: "rgba(245,242,238,0.2)" }} />
        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-serif-editorial text-lg md:text-2xl wide-track" style={{ letterSpacing: "0.28em" }}>
            REAL INFORMATION. REAL SUPPORT. REAL CHANGE.
          </div>
          <div className="overline" style={{ color: "var(--sand)" }}>SIBOINSTITUTE.COM</div>
        </div>
        <div className="mt-8 text-xs" style={{ color: "rgba(245,242,238,0.6)" }}>
          © {new Date().getFullYear()} SIBO Institute. Editorial content is for educational purposes and does not substitute for medical advice.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
